import { z } from "zod";

export interface IApiResponse<T> {
    success: boolean;
    statusCode: number;
    message: string;
    data: T;
}

export const paginationMetaSchema = z.object({
    totalCount: z.number(),
    pageSize: z.number(),
    limit: z.number(),
    currentPage: z.number(),
    totalPages: z.number(),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
});